import { Control, FieldValues, Path, useController } from 'react-hook-form'

import { ColoredSwitch } from '../../ColoredSwitch'

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
}

export const ControlledColoredSwitch = <T extends FieldValues>({
  control,
  name,
}: Props<T>) => {
  const { field } = useController({ control, name })

  return <ColoredSwitch {...field} ref={null} checked={field.value} />
}
